import React, { useState, useEffect } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import styles from "./DukamoMafiPage.module.css";

// --- DEFAULT ASSETS (Used if Admin is empty) ---
import mafiV60 from "../assets/Dukamo mafi/mafi-v60.jpg";
import mafiBarista from "../assets/Dukamo mafi/mafi-barista.jpg";
import mafiGallery1 from "../assets/Dukamo mafi/mafi-gallery-1.jpg";
import mafiGallery2 from "../assets/Dukamo mafi/mafi-gallery-2.jpg";
import mafiExteriorFooter from "../assets/Dukamo mafi/mafi-exterior-footer.jpg";

import slide1 from "../assets/Dukamo mafi/slide 1.jpg";
import slide2 from "../assets/Dukamo mafi/slide 2.jpg";
import slide3 from "../assets/Dukamo mafi/slide 3.jpg";
import slide4 from "../assets/Dukamo mafi/slide 4.jpg";
import slide5 from "../assets/Dukamo mafi/slide 5.jpg";
import slide6 from "../assets/Dukamo mafi/slide 6.jpg";

import foodSlide1 from "../assets/Dukamo mafi/foodslide 1.jpg";
import foodSlide2 from "../assets/Dukamo mafi/foodslide 2.jpg";
import foodSlide3 from "../assets/Dukamo mafi/foodslide 3.jpg";
import foodSlide4 from "../assets/Dukamo mafi/foodslide 4.jpg";
import foodSlide5 from "../assets/Dukamo mafi/foodslide 5.jpg";
import foodSlide6 from "../assets/Dukamo mafi/foodslide 6.jpg";

// Defaults for New Sections
import tournamentVideo from "../assets/Videos/tournament.mp4";
import tournamentThumbnail from "../assets/Videos/tournament-thumbnail.jpg";
import runner1 from "../assets/Dukamo mafi/1.jpg";
import runner2 from "../assets/Dukamo mafi/2.jpg";
import runner3 from "../assets/Dukamo mafi/3.jpg";
import runner4 from "../assets/Dukamo mafi/4.jpg";

// Default Arrays
const defaultTopSliderImages = [slide1, slide2, slide3, slide4, slide5, slide6];
const foodSliderImages = [
  foodSlide1,
  foodSlide2,
  foodSlide3,
  foodSlide4,
  foodSlide5,
  foodSlide6,
];
const defaultRunnerImages = [runner1, runner2, runner3, runner4];

function DukamoMafiPage() {
  const [currentTopSlide, setCurrentTopSlide] = useState(0);
  const [currentFoodSlide, setCurrentFoodSlide] = useState(0);
  const [currentRunnerSlide, setCurrentRunnerSlide] = useState(0);

  const [content, setContent] = useState({ textFields: {}, imageFields: {} });
  const [topSliderImages, setTopSliderImages] = useState(
    defaultTopSliderImages
  );

  // New State for Runner Up Slider
  const [runnerUpImages, setRunnerUpImages] = useState(defaultRunnerImages);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get("/api/pages/location-mafi")
      .then((res) => {
        if (res.data) {
          setContent(res.data);

          // 1. Build Dynamic Top Slider (introSlide_0, introSlide_1...)
          const dynamicSlider = [];
          if (res.data.imageFields) {
            for (let i = 0; i < 20; i++) {
              const key = `introSlide_${i}`;
              if (res.data.imageFields[key]) {
                dynamicSlider.push(`${res.data.imageFields[key]}`);
              }
            }
          }
          if (dynamicSlider.length > 0) setTopSliderImages(dynamicSlider);

          // 2. Build Dynamic Runner-Up Slider (runnerSlide_0, runnerSlide_1...)
          const dynamicRunner = [];
          if (res.data.imageFields) {
            for (let i = 0; i < 10; i++) {
              const key = `runnerSlide_${i}`;
              if (res.data.imageFields[key]) {
                dynamicRunner.push(`${res.data.imageFields[key]}`);
              }
            }
          }
          if (dynamicRunner.length > 0) setRunnerUpImages(dynamicRunner);
        }
      })
      .catch((err) => console.log("Using default content"));
  }, []);

  const getText = (key, fallback) =>
    content.textFields && content.textFields[key]
      ? content.textFields[key]
      : fallback;
  const getImage = (key, fallback) =>
    content.imageFields && content.imageFields[key]
      ? `${content.imageFields[key]}`
      : fallback;

  // --- SLIDER INTERVALS ---
  useEffect(() => {
    const topSlideInterval = setInterval(
      () => setCurrentTopSlide((prev) => (prev + 1) % topSliderImages.length),
      5000
    );
    return () => clearInterval(topSlideInterval);
  }, [topSliderImages]);

  useEffect(() => {
    const foodSlideInterval = setInterval(
      () => setCurrentFoodSlide((prev) => (prev + 1) % foodSliderImages.length),
      4000
    );
    return () => clearInterval(foodSlideInterval);
  }, []);

  useEffect(() => {
    const runnerInterval = setInterval(
      () => setCurrentRunnerSlide((prev) => (prev + 1) % runnerUpImages.length),
      3500
    );
    return () => clearInterval(runnerInterval);
  }, [runnerUpImages]);

  // --- NAVIGATION FUNCTIONS ---
  const nextSlide = () =>
    setCurrentTopSlide((prev) => (prev + 1) % topSliderImages.length);
  const prevSlide = () =>
    setCurrentTopSlide(
      (prev) => (prev - 1 + topSliderImages.length) % topSliderImages.length
    );
  const goToTopSlide = (index) => setCurrentTopSlide(index);

  const nextFoodSlide = () =>
    setCurrentFoodSlide((prev) => (prev + 1) % foodSliderImages.length);
  const prevFoodSlide = () =>
    setCurrentFoodSlide(
      (prev) => (prev - 1 + foodSliderImages.length) % foodSliderImages.length
    );
  const goToFoodSlide = (index) => setCurrentFoodSlide(index);

  const nextRunnerSlide = () =>
    setCurrentRunnerSlide((prev) => (prev + 1) % runnerUpImages.length);
  const prevRunnerSlide = () =>
    setCurrentRunnerSlide(
      (prev) => (prev - 1 + runnerUpImages.length) % runnerUpImages.length
    );

  return (
    <div className={styles.locationPage}>
      <Navbar />

      {/* 1. INTRO */}
      <section className={styles.locationIntro}>
        <div className={styles.introText}>
          <h1>{getText("introTitle", "Dukamo Mafi")}</h1>
          <p
            className={styles.introSubheading}
            style={{ whiteSpace: "pre-line" }}
          >
            {getText(
              "introText",
              "Step into Dukamo Mafi, where the speciality coffee meets a warm and inviting atmosphere..."
            )}
          </p>
        </div>
      </section>

      {/* 2. TOP SLIDER */}
      <section className={`${styles.imageSliderSection} ${styles.topSlider}`}>
        <div className={styles.sliderContainer}>
          {topSliderImages.map((image, index) => (
            <div
              key={`${index}-${image}`}
              className={`${styles.slide} ${
                index === currentTopSlide ? styles.active : ""
              }`}
            >
              <img src={image} alt={`Dukamo Mafi Slide ${index + 1}`} />
            </div>
          ))}
          <button
            className={`${styles.sliderArrow} ${styles.prev}`}
            onClick={prevSlide}
          >
            <FaChevronLeft />
          </button>
          <button
            className={`${styles.sliderArrow} ${styles.next}`}
            onClick={nextSlide}
          >
            <FaChevronRight />
          </button>
          <div className={styles.sliderDots}>
            {topSliderImages.map((_, index) => (
              <span
                key={index}
                className={`${styles.dot} ${
                  index === currentTopSlide ? styles.active : ""
                }`}
                onClick={() => goToTopSlide(index)}
              ></span>
            ))}
          </div>
        </div>
      </section>

      {/* 3. FEATURE: DRINKS */}
      <section className={`${styles.locationFeature} ${styles.featureDrinks}`}>
        <div className={styles.featureImage}>
          <img
            src={getImage("featureImage1", mafiV60)}
            alt="V60 Filter Coffee"
          />
        </div>
        <div className={styles.featureText}>
          <h2>
            {getText("featureTitle1", "Exceptional Coffee & Signature Drinks")}
          </h2>
          <p style={{ whiteSpace: "pre-line" }}>
            {getText(
              "featureText1",
              "We take pride in offering an exclusive V60 filter menu..."
            )}
          </p>
        </div>
      </section>

      {/* --- VIDEO SECTION (Now uses Admin Data) --- */}
      <section className={styles.videoFeatureSection}>
        <div className={styles.videoContainer}>
          <video
            className={styles.tournamentVideo}
            controls
            // Gets "videoThumbnail" from Admin, or uses local fallback
            poster={getImage("videoThumbnail", tournamentThumbnail)}
          >
            {/* Gets "videoSource" from Admin, or uses local fallback */}
            <source
              src={getImage("videoSource", tournamentVideo)}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
        <p className={styles.videoCaption}>
          {getText("videoCaption", "Experience the Art of Competition")}
        </p>
      </section>

      {/* 4. CHAMPION 1: ABATU */}
      <section
        className={`${styles.locationFeature} ${styles.featureChampions}`}
      >
        <div className={styles.featureText}>
          <h2>
            {getText("featureTitle2", "Home of Champions & Coffee Culture")}
          </h2>
          <p style={{ whiteSpace: "pre-line" }}>
            {getText("featureText2", "One of our own, Barista Abatu...")}
          </p>
        </div>
        <div className={styles.featureImage}>
          <img
            src={getImage("featureImage2", mafiBarista)}
            alt="Barista Abatu"
          />
        </div>
      </section>

      {/* 5. CHAMPION 2: FISSEHA (FLIPPED) */}
      <section
        className={`${styles.locationFeature} ${styles.featureChampions}`}
        style={{ flexDirection: "row-reverse" }}
      >
        <div className={styles.featureText} style={{ textAlign: "left" }}>
          <h2>{getText("championTitle2", "2025 1st Runner Up")}</h2>
          <p style={{ whiteSpace: "pre-line" }}>
            {getText(
              "championText2",
              "Introducing Fisseha, our talented barista..."
            )}
          </p>
        </div>
        <div className={styles.featureImage}>
          <img
            src={getImage("championImage2", mafiBarista)}
            alt="Barista Fisseha"
          />
        </div>
      </section>

      {/* --- RUNNER UP SLIDER (Now uses Admin Data) --- */}
      <section className={styles.runnerUpGallerySection}>
        <div className={styles.runnerUpContainer}>
          {runnerUpImages.map((image, index) => (
            <div
              key={index}
              className={`${styles.slide} ${
                index === currentRunnerSlide ? styles.active : ""
              }`}
            >
              <img src={image} alt={`Championship Highlight ${index + 1}`} />
              <div className={styles.slideOverlay}>
                <span>
                  {getText("runnerSliderText", "Championship Highlights")}
                </span>
              </div>
            </div>
          ))}
          <button
            className={`${styles.sliderArrow} ${styles.prev}`}
            onClick={prevRunnerSlide}
          >
            <FaChevronLeft />
          </button>
          <button
            className={`${styles.sliderArrow} ${styles.next}`}
            onClick={nextRunnerSlide}
          >
            <FaChevronRight />
          </button>
        </div>
      </section>

      {/* 6. FOOD SECTION */}
      <section className={styles.featureFoodSection}>
        <div className={styles.foodIntroText}>
          <h2>{getText("foodTitle", "More Than Just Coffee")}</h2>
          <p style={{ whiteSpace: "pre-line" }}>
            {getText("foodText", "Beyond our expertly brewed coffee...")}
          </p>
        </div>
        <div
          className={`${styles.imageSliderSection} ${styles.foodSliderSection}`}
        >
          <div className={`${styles.sliderContainer} ${styles.foodSlider}`}>
            {foodSliderImages.map((image, index) => (
              <div
                key={index}
                className={`${styles.slide} ${
                  index === currentFoodSlide ? styles.active : ""
                }`}
              >
                <img src={image} alt={`Food Slide ${index + 1}`} />
              </div>
            ))}
            <button
              className={`${styles.sliderArrow} ${styles.prev}`}
              onClick={prevFoodSlide}
            >
              <FaChevronLeft />
            </button>
            <button
              className={`${styles.sliderArrow} ${styles.next}`}
              onClick={nextFoodSlide}
            >
              <FaChevronRight />
            </button>
          </div>
        </div>
      </section>

      {/* 7. GALLERY & FOOTER */}
      <section className={styles.locationFooterGallery}>
        <div className={styles.galleryColumn}>
          <img
            src={getImage("galleryImage1", mafiGallery1)}
            alt="Dukamo Mafi Interior 1"
          />
          <img
            src={getImage("galleryImage2", mafiGallery2)}
            alt="Dukamo Mafi Interior 2"
          />
        </div>
        <div className={styles.footerInfoColumn}>
          <img
            src={getImage("footerImage", mafiExteriorFooter)}
            alt="Dukamo Mafi Exterior Night"
            className={styles.mafiExteriorFooterImg}
          />
        </div>
      </section>

      {/* 8. CONTACT */}
      <section className={styles.contactHoursBottomSection}>
        <div className={styles.contactInfo}>
          <h3>Contact Us</h3>
          <p>Phone: {getText("contactPhone", "(+251)-93-344-3322")}</p>
          <p>Email: {getText("contactEmail", "info@bunchocoffee.com")}</p>
        </div>
        <div className={styles.hoursInfo}>
          <h3>Hours of operation</h3>
          <p>{getText("hours", "Monday to Sunday 08:00 AM – 09:00 PM")}</p>
          <p>Location: {getText("address", "Mafi City Mall, Ground floor")}</p>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default DukamoMafiPage;
